import { validators } from "utils";

const {
  validateCron,
  validateDuration,
  validateEmail,
  validateJira,
  validateJiraURL,
  validateNoSpecialCharacters,
  validateNoStartingOrTrailingWhitespace,
  validatePercentage,
  validateRegexp,
  validateSSHPublicKey,
  validateSlack,
  validateURL,
  validateURLTemplate,
} = validators;

export const customFormats = (jiraHost = "") => ({
  noSpecialCharacters: validateNoSpecialCharacters,
  // Permit empty string but disallow whitespace
  noSpaces: /^$|^\S+$/,
  noStartingOrTrailingWhitespace: validateNoStartingOrTrailingWhitespace,
  validCron: validateCron,
  validDuration: validateDuration,
  validEmail: validateEmail,
  validJiraTicket: validateJira,
  validJiraURL: (url: string) => validateJiraURL(jiraHost, url),
  validPercentage: validatePercentage,
  validRegex: validateRegexp,
  validSlack: validateSlack,
  validURL: validateURL,
  validURLTemplate: validateURLTemplate,
  validSSHPublicKey: validateSSHPublicKey,
});
